import React, { FC } from 'react';
import { getProductionBatchByProductionOrderId, productionOrdersSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { connect } from 'react-redux';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { ImagesDocumentsContent } from '@v2/pages/nc-file/details/modules/nc-file/components/ImagesDocumentsContent';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { ProductionOrderScreenProps } from '@v2/pages/productionOrder/common/interfaces';
import { useProductionOrderDetails } from '@v2/pages/common/hooks/useProductionOrderDetails';
import { loadSingleBatch } from '@reducers/batch';
import { getNCFilesByProductionOrderId } from '@reducers/manufacture';
import { View } from 'react-native';
import { DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';

interface ProductionOrderDetailsNCFileDocumentsProps extends ProductionOrderScreenProps {
  ncFileId: number | null;
}

const ProductionOrderDetailsNCFileDocumentsComponent: FC<ProductionOrderDetailsNCFileDocumentsProps> = ({
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
  productionOrdersSearch,
  ncFileId,
}) => {
  const title = useTitle();

  useProductionOrderDetails({
    productionOrdersSearch,
    getNCFilesByProductionOrderId,
    getProductionBatchByProductionOrderId,
    loadSingleBatch,
    updateHeaderConfig,
    getAllNcFiles: true,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      {ncFileId != null && (
        <View style={DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES}>
          <ImagesDocumentsContent documentRetrieveId={ncFileId} documentRetrieveKey={DOCUMENT_ENTITY_TYPE.NcFile} />
        </View>
      )}
    </DetailsPageWrapper>
  );
};

const ProductionOrderDetailsNCFileDocuments = connect(({ details: { ncFileId } }) => ({ ncFileId }), {
  productionOrdersSearch,
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
})(ProductionOrderDetailsNCFileDocumentsComponent);

export { ProductionOrderDetailsNCFileDocuments };
